export interface IMembershipFeatures {
    onbeperktSporten: boolean;
    persoonlijkTrainingsplan: boolean;
    toegang: string;
    programmaUpdates: boolean;
    evaluatie: string;
    voortgangsmetingen: boolean;
    maandelijksOpzegbaar: boolean;
}

export interface IMembershipPackage {
    id: number;
    title: string;
    price: number;
    isAdvised?: boolean;
    features: IMembershipFeatures;
}

export const featureRows: { key: keyof IMembershipFeatures; label: string; tooltip?: string }[] = [
    { key: 'onbeperktSporten',        label: 'Onbeperkt sporten' },
    { key: 'persoonlijkTrainingsplan', label: 'Persoonlijk trainingsplan' },
    { key: 'toegang',                 label: 'Toegang' },
    { key: 'evaluatie',               label: 'Evaluatie',         tooltip: 'Periodiek evaluatiemoment om je voortgang te bespreken en je trainingsplan bij te stellen waar nodig.' },
    { key: 'programmaUpdates',        label: 'Programma-updates', tooltip: 'Je trainingsschema wordt iedere zes weken geëvalueerd en waar nodig aangepast op basis van je voortgang en doelen.' },
    { key: 'voortgangsmetingen',      label: 'Voortgangsmetingen' },
    { key: 'maandelijksOpzegbaar',    label: 'Maandelijks opzegbaar' },
];

export const membershipPackages: IMembershipPackage[] = [
    {
        id: 2,
        title: 'Basis',
        price: 85,
        features: {
            onbeperktSporten: true,
            persoonlijkTrainingsplan: true,
            toegang: '07:00 - 22:00',
            programmaUpdates: false,
            evaluatie: 'Elk kwartaal',
            voortgangsmetingen: false,
            maandelijksOpzegbaar: true,
        },
    },
    {
        id: 3,
        title: 'Basis Plus',
        price: 105,
        features: {
            onbeperktSporten: true,
            persoonlijkTrainingsplan: true,
            toegang: '07:00 - 22:00',
            programmaUpdates: true,
            evaluatie: 'Elke zes weken',
            voortgangsmetingen: true,
            maandelijksOpzegbaar: true,
        },
    },
    {
        id: 0,
        title: 'Dal',
        price: 65,
        features: {
            onbeperktSporten: true,
            persoonlijkTrainingsplan: true,
            toegang: '09:00 - 16:00',
            programmaUpdates: false,
            evaluatie: 'Elk kwartaal',
            voortgangsmetingen: false,
            maandelijksOpzegbaar: true,
        },
    },
    {
        id: 1,
        title: 'Dal Plus',
        price: 85,
        isAdvised: true,
        features: {
            onbeperktSporten: true,
            persoonlijkTrainingsplan: true,
            toegang: '09:00 - 16:00',
            programmaUpdates: true,
            evaluatie: 'Elke zes weken',
            voortgangsmetingen: true,
            maandelijksOpzegbaar: true,
        },
    },
];
